import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {TechnicalDeviceDataService} from './technical-device-data.service';
import {RoutesStorage} from '@helpers/routes.helper';

@Injectable()
export class TechnicalDevicesSummaryInfoResolver extends BaseResolverService {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        service: TechnicalDeviceApiService,
        router: Router,
        private dataService: TechnicalDeviceDataService,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const service = this.resolverService as TechnicalDeviceApiService;

        let {id} = snapshot.params;

        if (!id) {
            id = snapshot.parent.params;
        }

        this.dataService.deviceId = id;

        return {
            url: service.getSummaryInfoPath(id),
        };
    }

    processResolvedData(data) {
        this.dataService.setSummaryInfo(data);
        return data;
    }

    processNullData() {
        return null;
    }

    processError() {
        return null;
    }
}
